<template>
    <div>
        <slot :items="items" :get="get" :store="store" :loading="loading"></slot>
    </div>
</template>

<script>
export default {
    name: "DataFetch",

    props: {
        endpoint: {
            type: String,
            required: true
        },
        uriBindings: {
            type: Object,
            default: function() {
                return {};
            }
        },
        updateOn: {
            type: Array,
            default: function() {
                return [];
            }
        },
        queryParameters: {
            type: Object,
            default: function () {
                return {};
            }
        },
        fetchOnMount: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            items: [],
            store: {},
            loading: false
        }
    },

    computed: {
        uri() {
            let result = this.endpoint;
            
            for(let [key, value] of Object.entries(this.uriBindings)) {
                if(value == null || value == "") {
                    return null;
                }

                result = result.replace(":" + key, value);
            }
            return result;
        }
    },

    watch: {
        uri: {
            handler(newUri) {
                console.log('endpoint updated');
                console.log(newUri);

                if(newUri != null) {
                    //console.log('running get');
                    this.get();
                }
            }
        }
    },

    mounted() {
        // Add event listeners
        for(let listener of this.updateOn) {
            EventBus.$on(listener, event => {
                console.log('updating table');

                this.$nextTick(() => {
                    this.get();
                });
            });
        }

        if(this.fetchOnMount) {
            this.$nextTick(() => {
                this.get();
            })
        }

        EventBus.$on('updated-participant', this.updateOneItem);
    },

    methods: {
        get() {
            if(this.uri == null) {
                return;
            }

            this.loading = true;

            this.$nextTick(() => {
                axios.get(this.uri, {
                    params: this.queryParameters
                })
                .then(response => {
                    this.items = response.data;

                    // Store additional data
                    if(response.data.store) {
                        for(let [key, value] of Object.entries(response.data.store)) {
                            this.$set(this.store, key, value);
                        }
                    }
                    this.$emit('update', response.data);

                    this.loading = false;
                })
            })
        },

        updateOneItem(participantId){
            if(participantId == this.items.id){
                this.get();
            }
        }
    }
}
</script>

<style>

</style>